import { useContext } from 'react';

import { RemovalContext, RemovalProps } from '../contexts/Removal.context';

export const useRemoval = (): RemovalProps => useContext(RemovalContext);
